import { render, staticRenderFns } from "./ContractDialog.vue?vue&type=template&id=13c12fce"
import script from "./ContractDialog.vue?vue&type=script&lang=js"
export * from "./ContractDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports